(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description"] && !Shopify.designMode) return;
  try {
    function initCollapsibleText(container = document) {
        const wrappers = container.querySelectorAll('.text-block-wrapper');

        wrappers.forEach((wrapper) => {
            const text = wrapper.querySelector('[data-collapsible-text]');
            const button = wrapper.querySelector('[data-collapsible-toggle');

            if (!text || !button) return;

            const collapsedHeight = 180;

            if (text.scrollHeight <= collapsedHeight) {
            button.hidden = true;
            return;
            }

            button.hidden = false;

            button.addEventListener('click', () => {
            const expanded = text.classList.toggle('is-expanded');

            button.textContent = expanded ? 'Show less' : 'Show more';
            button.setAttribute('aria-expanded', expanded);
            });
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        initCollapsibleText();
    });

    document.addEventListener('shopify:section:load', (event) => {
        initCollapsibleText(event.target);
    });
  } catch(e) { console.error(e); }
})();

})();
